import Seo from "@/components/Seo";
import { useLang, route } from "../i18n";
import { useCompany, useSiteServices } from "../components/SiteContext";
import PageHero from "../components/PageHero";
import ServiceCard from "../components/ServiceCard";
import ProcessSteps from "../components/ProcessSteps";
import FinalCta from "../components/FinalCta";
import { SectionHead } from "../components/SectionHead";

const ServicesPage = () => {
  const { lang, t } = useLang();
  const company = useCompany();
  const services = useSiteServices();
  const s = t.servicesPage;

  return (
    <>
      <Seo title={s.seo.title} siteName={company.name} description={s.seo.description} />
      <PageHero
        eyebrow={s.eyebrow}
        lines={[s.title]}
        copy={s.copy}
        breadcrumb={[{ label: t.nav.home, to: route(lang, "home") }, { label: t.nav.services }]}
        testid="services-hero"
      />

      <section className="bg-[#F4F0E8]" data-testid="services-grid">
        <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((svc, i) => (
              <ServiceCard key={svc.slug} service={svc} delay={i * 0.08} />
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#EEE9DF]" data-testid="services-method">
        <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
          <SectionHead eyebrow={t.home.method.chapter} title={t.home.method.title} tone="light" />
          <div className="mt-16">
            <ProcessSteps steps={t.home.method.steps} tone="light" />
          </div>
        </div>
      </section>

      <FinalCta />
    </>
  );
};

export default ServicesPage;
